import React from 'react'
import { Grid, Button, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
    root: {
        maxWidth: 80,
        maxHeight: 80,
        width: 80,
        height: 80
    }
})

const NewBudgetCardapio = (props) => {

    const dados = props.dados

    const selItemPedidoPDV = props.onClickFunction

    return (
        <Grid container sm={12}>

            {dados.map((row, index) => (

                <Grid container sm={props.Size || 2} style={{ margin: 10 }} key={index}>
                    <Paper square elevation={3}>
                        <Grid sm={12} justify="center" alignItems="center">
                            <img src={row.image || "https://st2.depositphotos.com/4687049/6972/i/950/depositphotos_69725607-stock-photo-dish-with-meat-rice-and.jpg"} alt="Foto" style={{ width: '100%' }} />
                        </Grid>

                        <Grid container sm={12} display="flex" direction="row" justify="space-between" alignItems="center" style={{marginLeft: 2, marginRight: 2, minHeight: 50}} >
                            <span style={{ color: 'black', marginLeft: 5 }}>{row.titulo}</span>
                            <span style={{ color: 'black', marginRight: 5 }}>{`R$ ${row.valor_atual.toFixed(2)}`}</span>
                        </Grid>

                        <Grid sm={12} display="flex" direction="row" justify="center" alignItems="center" style={{ textAlign: 'right' }}>
                            <Button variant="outlined" style={{color: 'green', margin: 5}} onClick={()=>selItemPedidoPDV({titulo: row.titulo, valor_atual: row.valor_atual, produto_id: row.id, percent_cashback: row.percentual_cashback})}>Adicionar</Button>
                        </Grid>
                    </Paper>
                </Grid>
            ))
            }
        </Grid>
    )
}

export default NewBudgetCardapio